import { DownloadIcon } from '@rsos/assets/icons';
import { Text, Box } from '@rsos/components/capstone/base';
import {
  TextIcon,
  DownloadItems,
} from '../styles/CommunicationHistoryTable.styles';

/**
 *
 * @param {Function} onDropdownClose - Function to close dropdown
 * @param {Function} onDownloadClicked - Function to call when a download item is clicked
 * @param {string} text - The text to display in the dropdown item
 * @param {string} margin - Margin around the dropdown item
 * @param {boolean} downloadAll - Whether to download all items or not
 *
 * @returns {JSX Element} renders DropdownDownloadItem component
 */

export const DropdownDownloadItem = ({
  onDropdownClose = () => {},
  onDownloadClicked = () => {},
  text = '',
  margin = '0px',
  downloadAll = false,
}) => {
  const handleDropdownItemClick = (
    onDropdownClose,
    onDownloadClicked = () => {},
    downloadAll,
  ) => {
    onDropdownClose();
    onDownloadClicked(downloadAll);
  };

  return (
    <DownloadItems
      noRadius
      padding="8px"
      margin={margin}
      onClick={() =>
        handleDropdownItemClick(onDropdownClose, onDownloadClicked, downloadAll)
      }
    >
      <TextIcon align="center">
        <Box pr={1}>
          <DownloadIcon
            width={12}
            height={14}
            color="secondaryText"
            viewboxWidth={8}
            viewboxHeight={14}
          />
        </Box>
        <Text size="small" color="primaryText">
          {text}
        </Text>
      </TextIcon>
    </DownloadItems>
  );
};
